import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { continueMsg, t } from '../../common/i18n/index.js';
import { Password } from '../../common/react-hook-form/fields/Password.js';
import { useAuth } from '../../public/site/AuthProvider';
import { Anchor } from '../Anchor/Anchor.js';
import { ModalCloseAndSubmitButtons } from '../Modal/ModalCloseAndSubmitButtons.js';
import type { ForgetPasswordWithForm } from './misc/forgotPasswordInterfaces.js';

export const ForgotPasswordEnterOnetimePasswordStep = (props: ForgetPasswordWithForm) => {
  const { updateForgotPasswordStepNumber, validateOtp } = useAuth();
  const { methods } = props;

  const onSubmit = ({ otp, userName }: { otp: string; userName: string }) => {
    validateOtp({
      otp,
      userName,
    });
  };

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
      <div className="of-forgot-password-step__header">
        <h3 className={dsClass.H3_BOOK}>{t.GE17('Forgotten Password')}</h3>
      </div>

      <p>{t.KUKS('One-time password was sent to your phone number. Please use it when signing in to the service.')}</p>

      <Password name="otp" type="text" />

      {props.anonymousUser.forgotPasswordErrored && (
        <CL.Notification hasCloseButton={false} text={t.ZK2S('Please check your password')} type="warning" visible />
      )}

      <ModalCloseAndSubmitButtons
        onCancel={props.closeModal}
        onSubmit={() => {}}
        submitButtonText={t.I62A(continueMsg)}
        submitting={props.anonymousUser.forgotPasswordInProgress}
      />
      <Anchor
        className="link"
        onClick={() => {
          updateForgotPasswordStepNumber(1);
        }}
      >
        {t.UCAJ('Resend one-time password')}
      </Anchor>
    </form>
  );
};
